import { ContentHead } from '../../lib/components';
import { ContentBox } from '../../lib/components/compound/pages/contentBox';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../hooks/useStore';
import { useEffect, useMemo } from 'react';
import { useDate, useStatus } from '../profile/partials/profilePagesPartial';
import { useNavigate } from 'react-router';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { useSnackbar } from 'notistack';
import { ReceiptsTableViewModel } from './table/viewModel';
import { ReceiptsTableManagerViewModel } from './table/manager/viewModel';
import { ReceiptsTableManager } from './table/manager/component';

export const ReceiptsOverview = observer(() => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { companyStore, receiptStore, receiptListStore } = useStore();

  const [date] = useDate();
  const [statusFilter] = useStatus();
  const snackbar = useSnackbar();
  const mainTableRef = useGridApiRef();

  const tableManager = useMemo(() => {
    const tableViewModel = new ReceiptsTableViewModel(
      navigate,
      t,
      snackbar,
      receiptStore,
      mainTableRef
    );
    const manager = new ReceiptsTableManagerViewModel(
      tableViewModel,
      receiptListStore,
      companyStore
    );
    manager.loading.start();
    return manager;
  }, []);

  useEffect(() => {
    if (!companyStore.company) return;
    tableManager.setDateFilter(date);
  }, [date]);

  useEffect(() => {
    if (!companyStore.company) return;
    tableManager.setStatusFilter(statusFilter);
  }, [statusFilter]);

  return (
    <ContentBox headComponent={<ContentHead headline={t('common:RECEIPTS')} showActions={false} />}>
      <ReceiptsTableManager viewModel={tableManager} />
    </ContentBox>
  );
});
